<template>
    <div class="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-2" id="m_login" :style="{ backgroundImage: `url('${bgImage}')` }">
		<div class="m-grid__item m-grid__item--fluid m-login__wrapper">
			<div class="m-login__container">
				<div class="m-login__logo">
					<a href="#">
						<img src="../assets/img/logos/logo_login.jpg">
					</a>
				</div>
				<div class="m-login__signin">
					<div class="m-login__head">
						<h3 class="m-login__title"></h3>
					</div>
					<form class="m-login__form m-form" v-on:submit.prevent="preventSubmit()">
						<div v-if="errorMessage" class="form-group m-form__group error">
							<span class="error">{{errorMessage}}</span>
						</div>
						<div class="form-group m-form__group">
							<input v-model="username" class="form-control m-input" type="text" placeholder="Tên đăng nhập" name="username" autocomplete="off">
						</div>
						<div class="form-group m-form__group">
							<input v-model="password" class="form-control m-input m-login__form-input--last" type="password" placeholder="Mật khẩu" name="password">
						</div>
						<div class="m-login__form-action">
							<input @click="login" id="m_login_signin_submit" type="submit" class="btn btn-danger m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-login__btn--primary" value="Đăng nhập" />
						</div>
					</form>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import moment from 'moment';
	import { initAuthManager } from '../authManager';

    export default {
		data() {
			console.log("errMess", this.$route.params.message);
            return {
				username: "",
				password: "",
				bgImage: require('../assets/img/bg/bg-10.jpg'),
				errorMessage: this.$route.params.message || ""
            }
        },
        methods: {
        	preventSubmit: function(){
        		return false;
        	},
			login: async function() {
				if(this.username == "" || this.password == "") {
					this.errorMessage = "Thông tin đăng nhập không được để trống";
					return false;
				}

				let token = await window.axios.post(process.env.VUE_APP_API + '/v1/admin-panel/login', {
					user: this.username,
					pass: this.password
				});

				let vm = this;
				if(token.data.code == 0){
					token.data.data.expired_at = moment().add(token.data.data.expires_in, 'seconds');

					localStorage.setItem('token', JSON.stringify(token.data.data));
					initAuthManager();

					window.setTimeout(()=>{
						vm.$router.replace({ name: "Home" });
					}, 100);

					
						// Swal({
						//   title: 'Thông báo',
						//   text: 'Event hiện tại xyz !'
						// });
				}

			}
		}
	}
</script>

<style>
    .error {
		text-align: center;
		color: red;
		font-size: medium;
    }
    .m-login.m-login--2 .m-login__wrapper .m-login__container .m-login__form .m-form__group .form-control{
    	padding: 1rem;
    }
    .m-login__container {
    	overflow: hidden;
	    box-shadow: 0 5px 12px rgba(0,0,0,.2);
	    position: relative;
	    padding: 35px 100px 30px;
	    border-radius: 10px;
	    background: transparent;
	    background-color: rgba(255, 255, 255, 0.2);
    }
    #m_login .m-login__form.m-form{
    	margin: 0 auto;
    }
    @media only screen and (max-width: 767px) {
	 	#m_login{
	 		background-position: -381px 0;
    		background-size: cover;
	 	}
	}
</style>